<template>
  <section class="page-panel">
    <header class="page-panel__header page-panel__header--with-action">
      <h3 class="panel-title">Oprema vozila</h3>
      <v-btn
        v-if="!readonly"
        class="button button--secondary button--small"
        prepend-icon="mdi-plus"
        variant="outlined"
        @click="$emit('update:equipment', [...equipment, ''])"
      >Dodaj polje</v-btn>
    </header>
    <div class="page-panel__content grid-stack grid-row-gap-18">
      <template v-if="!readonly">
        <AppTextField model-value="Vatrogasni aparat" readonly />
        <AppTextField model-value="Komplet obvezne opreme" readonly />
        <div v-for="(item, index) in equipment" :key="index" class="record-equipment__row">
          <AppTextField
            :model-value="item"
            placeholder="Unesite naziv opreme..."
            :rules="[(value) => String(value ?? '').trim().length <= 255 || 'Najviše 255 znakova']"
            @update:model-value="setItem(index, $event)"
          />
          <v-btn
            aria-label="Ukloni polje"
            icon="mdi-minus"
            size="small"
            variant="text"
            @click="$emit('update:equipment', equipment.filter((_, itemIndex) => itemIndex !== index))"
          />
        </div>
      </template>
      <template v-else>
        <p class="record-equipment__item">Vatrogasni aparat</p>
        <p class="record-equipment__item">Komplet obvezne opreme</p>
        <p v-for="(item, index) in equipment.filter(Boolean)" :key="index" class="record-equipment__item">{{ item }}</p>
      </template>
    </div>
  </section>
</template>

<script setup>
import AppTextField from '../AppTextField.vue'

const props = defineProps({
  equipment: { type: Array, default: () => [] },
  readonly: { type: Boolean, default: false },
})

const emit = defineEmits(['update:equipment'])

function setItem (index, value) {
  const equipment = [...props.equipment]
  equipment[index] = value
  emit('update:equipment', equipment)
}
</script>

<style scoped lang="scss">
.record-equipment {
  &__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
  }

  &__item {
    margin: 0;
    color: var(--color-text-body);
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }
}
</style>
